angular.module('impactx.ruleset').controller('RuleInvoiceCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    RuleInvoiceCtrl]);

function RuleInvoiceCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {
        id: $routeParams.id,
        ruleSetId: $routeParams.ruleSetId,
        ruleType: $routeParams.ruleType
    }, "/ruleset/viewinvoicerule").then(function () {
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        defineButtons();
    });

    this.save = function () {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/ruleset/saveinvoicerule").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    this.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/ruleset/deleterule").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}